module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "boxes"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("FluPRINT on-line interface")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.databaseData === null),
      expression: "databaseData === null"
    }]
  }, [_vm._v("Please wait, loading example data...")]), _vm._v(" "), _c('hotTable', {
    ref: "hotTableComponent",
    attrs: {
      "settings": _vm.hotSettings
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.pageLoading == true) ? _c('div', {
    staticClass: "page-loading-outer"
  }, [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro",
    staticStyle: {
      "font-size": "16px",
      "max-width": "80%"
    }
  }, [_vm._v("\n            Here you can browse simplified example data contained in FluPrint MySQL database. We suggest building database from source by following directions explained\n            "), _c('a', {
    staticStyle: {
      "color": "#7386D5"
    },
    attrs: {
      "href": "https://github.com/LogIN-/fluprint",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(" on our\n            "), _c('a', {
    staticStyle: {
      "color": "#7386D5"
    },
    attrs: {
      "href": "https://github.com/LogIN-/fluprint",
      "target": "_blank"
    }
  }, [_vm._v("main git repository")]), _vm._v(". In the case you don't know want to do that you can\n            also "), _c('a', {
    staticStyle: {
      "color": "#7386D5"
    },
    attrs: {
      "href": "https://zenodo.org/record/3222451#.XOb7MaR7lPY",
      "target": "_blank"
    }
  }, [_vm._v("download full database export")]), _vm._v(" in CSV format\n            "), _c('a', {
    staticStyle: {
      "color": "#7386D5"
    },
    attrs: {
      "href": "https://zenodo.org/record/3222451#.XOb7MaR7lPY",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsors"
  }, [_vm._v("\n            This work is supported by the EU’s Horizon 2020 research and innovation program under the Marie Sklodowska-Curie"), _c('br'), _vm._v("\n            Grant (FluPRINT, Project No 796636) and National Institutes of Health (NIH) grants (U19 AI090019, U19 AI057229) "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": "sponsors/ec-logo-horiz-web_en.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "max-height": "50px",
      "margin-left": "10px"
    },
    attrs: {
      "src": "sponsors/nih-logo-color.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-loading-inner spinner-grow text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b57e73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/database-access/index.vue
// module id = 1224
// module chunks = 1